
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/topics/[topic]/articles",
      function () {
        return require("private-next-pages/learn/topics/[topic]/articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/topics/[topic]/articles"])
      });
    }
  